import {UI_COLORS} from '@/utils/ui-colors';

export function getFileCategoryColor(item) {
    return item && item.category && item.category.color ? item.category.color : UI_COLORS.border.default;
}

export function getFileRowKey(item) {
    if (!item) {
        return 'missing-item';
    }

    return item.uuid || item.id || `${item.name || 'file'}-${item.created_at || 'na'}`;
}

export function resolveFileIcon(extension) {
    const ext = String(extension || '').toLowerCase();
    const supported = [
        'pdf', 'png', 'jpg', 'jpeg', 'gif', 'svg', 'bmp', 'raw', 'psd', 'ai', 'eps',
        'xls', 'xlsx', 'csv', 'doc', 'docx', 'ppt', 'pptx', 'txt', 'xml', 'html', 'css',
        'js', 'php', 'py', 'java', 'zip', 'rar', '7zip', 'tgz', 'mp3', 'wav', 'mp4', 'avi'
    ];

    if (ext === 'csv') {
        return 'file-extension.xls';
    }

    return supported.includes(ext) ? `file-extension.${ext}` : 'file-extension.default';
}

export function resolveFileUserAvatar(user) {
    if (!user) {
        return '';
    }

    return user.avatar && user.avatar !== 'gravatar' ? user.avatar : user.gravatar;
}

export function buildFilePreviewUrl(item, token) {
    const base = item && item.preview_url ? item.preview_url : '';
    if (!base) {
        return `${item.download}?token=${token}`;
    }

    const separator = base.includes('?') ? '&' : '?';
    return `${base}${separator}token=${token}`;
}

export function isImageFileExtension(extension) {
    const ext = String(extension || '').toLowerCase();
    return ['png', 'jpg', 'jpeg', 'gif', 'svg', 'bmp', 'webp'].includes(ext);
}

export function buildShortDescriptionTooltip(text) {
    if (!text) {
        return '';
    }

    return String(text)
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}
